import { LEFT_NAV_ACTION_BUTTON_WIDTH } from '@/components/common/pageLayout/LeftNavActionButton';
import { PRIVACY_MODE_KEY } from '@/util/localStorage';
import { Box } from '@chakra-ui/react';
import useLocalStorageState from 'use-local-storage-state';
import { EyeOff } from '../icons';
import { Text } from '../Typography';

const PrivacyModeTag = () => {
    const [privacyModeEnabled] = useLocalStorageState(PRIVACY_MODE_KEY, {
        defaultValue: false,
    });
    if (!privacyModeEnabled) return null;

    return (
        <Box
            px={2}
            py={1}
            bg="gray.100"
            color="blue.700"
            fontSize="sm"
            fontWeight="semibold"
            rounded="full"
            display="flex"
            alignItems="center"
            borderColor="blue.700"
            borderWidth={1}
            w={LEFT_NAV_ACTION_BUTTON_WIDTH}
        >
            <EyeOff mr={2} size="sm" />
            <Text fontWeight="semibold" fontSize="2xs">
                PRIVACY MODE ENABLED
            </Text>
        </Box>
    );
};

export default PrivacyModeTag;
